import Timeline from './lib/timeline';
import validator from 'utils/validator';
import 'components/empty_list_message';
import 'components/campaigns/interventions/square_banner';
import 'components/practice_test_banner';
import 'components/cms/render_component';

import './components/new_activity';
import './components/timeline_filter';
import './components/timeline_loader';
import './components/sidebar_box';
import './components/cta';
import './components/achievements/sidebar_achievement_box';
import './components/achievements/big_achievement_box';
import './components/achievements/all_achievements';
import './components/achievements/badges_icons';

import './components/activity/index.scss';
import './components/activity_comment/index.scss';
import './components/activity_reply/index.scss';

import '../xray/components/meet';

import '../timeline/components/resources_box';

(function () {
  'use strict';
  validator.init();
  new Timeline().start();
})();
